import React, { useState, useContext, useEffect} from 'react';
import { useParams } from 'react-router';
import { Row, Col } from 'react-bootstrap';
import BasicDetailsSection from "./components/section-basic-details/section-basic-details";
import ActionsSection from "./components/section-actions/section-actions";
import TabsSection from "./components/section-tabs/section-tabs";
import styles from './security-details.module.scss';
import {SecurityDispatchContext, REDUCER_ACTION_INITIALIZE, SecurityContext} from '../../../context/security-context';
import SecurityService from "../../../services/security-service";
import {Security} from "../../../models/security";
import Loading from "../../../components/loading/loading";
import Order from "../../../models/order";

/*
  Security Details Page Main Layout
 */
const SecurityDetails = () => {
  //Set spinner state
  const [loading, setLoading] = useState(true);

  //Get username and security state dispatcher
  const { ordersState } = useContext(SecurityContext);
  const { setSecurityState, ordersDispatch } = useContext(SecurityDispatchContext);

  //Initialize Service
  const securityService = new SecurityService();

  //Retrieve security id from params
  const { securityId }  = useParams();

  //Set security details within the context
  useEffect(() => {
    const initializeSecurityDetails = async () => {
      let security = await securityService.getSecurityOffer(securityId);
      console.log(security);
      setSecurityState(new Security(security));

      const orders = await securityService.getListOfOrders(securityId);
      const ordersList = orders.map((order) => new Order(order));
      ordersDispatch({
        type: REDUCER_ACTION_INITIALIZE,
        previous: ordersState,
        data: ordersList
      });
      //Set loading to false
      setLoading(false);
    }
    initializeSecurityDetails()
    // eslint-disable-next-line
  }, []);

  return loading
    ? <Loading fullscreen={true}/>
    : <div className={styles['security-main-details']}><SecurityLayout/></div>;
}

const SecurityLayout = () => {
  return (
    <Row>
      <Col lg={4}>
        <Row>
          <BasicDetailsSection />
        </Row>
        <Row>
          <div className={styles['line']}></div>
        </Row>
        <Row>
          <ActionsSection />
        </Row>
      </Col>
      <Col lg={8}>
        <Row>
          <TabsSection />
        </Row>
      </Col>
    </Row>
  );
}

export default SecurityDetails;
